// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bs-primary: #2489a5 !important;
    --bs-btn-border-radius: 0.625rem;
    --loginButtonHoverColor: #2489a5;
    font-family: "OpenSans";
    --bs-btn-font-size: 1.15rem;
    --bs-error: #ff0000;
    --bs-aside-bg-color: #e5e5e5;
    --bs-header-bg-color: black;
    --bs-page-bg: #f4f4f4;
    font-family: 'Open Sans', sans-serif;
}

#splash {
    position: fixed;
    z-index: 5000;
    background-color: white;
    opacity: 0.5;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw !important;
    height: 100vh !important;
    display: none;
}

.lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    z-index: 5001;
    top: 50%;
    left: 50%;
    margin-left: -40px;
    margin-top: -40px;
}

.lds-ripple div {
    position: absolute;
    border: 4px solid #fff;
    opacity: 1;
    border-radius: 50%;
    background: var(--bs-primary);
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
}

@keyframes lds-ripple {
    0% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 0;
    }

    4.9% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 0;
    }

    5% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 1;
    }

    100% {
        top: 0px;
        left: 0px;
        width: 72px;
        height: 72px;
        opacity: 0;
    }
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
    scrollbar-width: auto !important;
    scrollbar-color: var(--bs-primary) #ffffff !important;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px !important;
    height: 16px !important;
}

*::-webkit-scrollbar-track {
    background: #ffffff !important;
}

*::-webkit-scrollbar-thumb {
    background-color: var(--bs-gray-400) !important;
    border-radius: 10px !important;
    border: 3px solid #ffffff !important;
}

 button.btn-primary{
    background-color: var(--bs-primary);
    border: solid 1px var(--bs-primary);
 }

 button.btn-primary:hover,
 button.btn-primary:active,
 button.btn-primary:focus{
    background-color: #27687a !important;
    border: solid 1px #27687a !important;
    outline: none !important;
 }

 .form-check-input{
    border: solid 1px #aaa !important;
 }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,6BAA6B;IAC7B,8DAA8D;AAClE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;QACT,UAAU;IACd;;IAEA;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;QACT,UAAU;IACd;;IAEA;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;QACT,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA,8BAA8B;AAC9B,YAAY;AACZ;IACI,gCAAgC;IAChC,qDAAqD;AACzD;;AAEA,6BAA6B;AAC7B;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;IAC9B,oCAAoC;AACxC;;CAEC;IACG,mCAAmC;IACnC,mCAAmC;CACtC;;CAEA;;;IAGG,oCAAoC;IACpC,oCAAoC;IACpC,wBAAwB;CAC3B;;CAEA;IACG,iCAAiC;CACpC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;700&display=swap');\n\n:root {\n    --bs-primary: #2489a5 !important;\n    --bs-btn-border-radius: 0.625rem;\n    --loginButtonHoverColor: #2489a5;\n    font-family: \"OpenSans\";\n    --bs-btn-font-size: 1.15rem;\n    --bs-error: #ff0000;\n    --bs-aside-bg-color: #e5e5e5;\n    --bs-header-bg-color: black;\n    --bs-page-bg: #f4f4f4;\n    font-family: 'Open Sans', sans-serif;\n}\n\n#splash {\n    position: fixed;\n    z-index: 5000;\n    background-color: white;\n    opacity: 0.5;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100vw !important;\n    height: 100vh !important;\n    display: none;\n}\n\n.lds-ripple {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n    z-index: 5001;\n    top: 50%;\n    left: 50%;\n    margin-left: -40px;\n    margin-top: -40px;\n}\n\n.lds-ripple div {\n    position: absolute;\n    border: 4px solid #fff;\n    opacity: 1;\n    border-radius: 50%;\n    background: var(--bs-primary);\n    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n\n.lds-ripple div:nth-child(2) {\n    animation-delay: -0.5s;\n}\n\n@keyframes lds-ripple {\n    0% {\n        top: 36px;\n        left: 36px;\n        width: 0;\n        height: 0;\n        opacity: 0;\n    }\n\n    4.9% {\n        top: 36px;\n        left: 36px;\n        width: 0;\n        height: 0;\n        opacity: 0;\n    }\n\n    5% {\n        top: 36px;\n        left: 36px;\n        width: 0;\n        height: 0;\n        opacity: 1;\n    }\n\n    100% {\n        top: 0px;\n        left: 0px;\n        width: 72px;\n        height: 72px;\n        opacity: 0;\n    }\n}\n\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n    scrollbar-width: auto !important;\n    scrollbar-color: var(--bs-primary) #ffffff !important;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n    width: 16px !important;\n    height: 16px !important;\n}\n\n*::-webkit-scrollbar-track {\n    background: #ffffff !important;\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: var(--bs-gray-400) !important;\n    border-radius: 10px !important;\n    border: 3px solid #ffffff !important;\n}\n\n button.btn-primary{\n    background-color: var(--bs-primary);\n    border: solid 1px var(--bs-primary);\n }\n\n button.btn-primary:hover,\n button.btn-primary:active,\n button.btn-primary:focus{\n    background-color: #27687a !important;\n    border: solid 1px #27687a !important;\n    outline: none !important;\n }\n\n .form-check-input{\n    border: solid 1px #aaa !important;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
